import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-primary-button",
  templateUrl: "./primary-button.component.html",
  styleUrls: ["./primary-button.component.scss"],
})
export class PrimaryButtonComponent implements OnInit {
  @Input() label: string;
  @Input() type: string = "button";
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<MouseEvent>();

  onClickButton(event: MouseEvent) {
    this.onClick.emit(event);
  }
  constructor() {
    this.label = "";
  }

  ngOnInit(): void {}
}
